import {useEffect, useMemo} from 'react';

const PREFIX = 'ui-messages';

const getKeys = () =>
    Object.keys(localStorage).filter((key) => key.startsWith('ui-messages-'));

const getMessages = <T extends string>() =>
    Object.fromEntries(
        getKeys().map((key) => [
            key.split(`${PREFIX}-`)[1],
            localStorage.getItem(key) as string,
        ]),
    ) as {[key in T]: string};

export const jestGetMessages = getMessages;

export const setMessage = (key: string, message: string) => {
    localStorage.setItem(`${PREFIX}-${key}`, message);
};

const clearMessages = () => {
    getKeys().forEach((key) => localStorage.removeItem(key));
};

type UseMessageProps = {
    [K: string]: string | undefined;
};

const useMessage = <T extends string>(): UseMessageProps => {
    useEffect(() => {
        setTimeout(clearMessages, 1000);
    }, []);

    return useMemo(() => getMessages<T>(), []);
};

export default useMessage;
